import React from "react";
import { Chip } from "@mui/material";
import { getStatusChipProps } from "../utils";

/**
 * StatusChip - A reusable component for displaying status with consistent colors
 * @param {string} status - The status value (e.g., "indexed", "pending_review")
 * @param {string} variant - Chip variant ("filled", "outlined") - default: "filled"
 * @param {string} size - Chip size ("small", "medium") - default: "small"
 * @param {object} sx - Additional Material-UI sx props
 * @param {object} ...props - Additional props to pass to the Chip component
 */
const StatusChip = ({
  status,
  variant = "filled",
  size = "small",
  sx = {},
  ...props
}) => {
  const chipProps = getStatusChipProps(status);

  return (
    <Chip
      label={chipProps.label}
      color={chipProps.color}
      variant={variant}
      size={size}
      sx={{
        fontWeight: 500,
        ...sx,
      }}
      {...props}
    />
  );
};

export default StatusChip;
